<template>
  <v-menu
    close-on-click
    close-on-content-click
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon
      >
        <v-avatar size="32px">
          <img
            :src="`${require('@/assets/images/profile-man.svg')}`"
            alt="Vuetify"
          >
        </v-avatar>
      </v-btn>
    </template>

    <!-- list -->
    <v-list class="header">
      <template v-if="!isMobile">
        <v-list-item
          v-for="(item, index) in loggedUserMenu"
          :key="index"
          :class="item.link !== '/profile' ? '' : 'bg-link'"
        >
          <v-list-item-title>
            <router-link :to="item.link">{{ item.title }}</router-link>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-else-if="isMobile">
        <v-list-item
          v-for="(item, index) in loggedUserMenuMobile"
          :key="index"
          :class="item.link !== '/profile' ? '' : 'bg-link'"
        >
          <v-list-item-title>
            <router-link
              :to="item.link"
              :class="item.link !== '/profile' ? 'secondary--text' : ''">{{ item.title }}</router-link>
          </v-list-item-title>
        </v-list-item>
      </template>

      <!-- logout -->
      <v-list-item
        @click="logout('json')"
        class="bg-link"
      >
        <v-list-item-title
          class="error--text"
          style="font-size: 0.875em;">{{ this.$t('nav.dropdow.item-2') }}</v-list-item-title>
      </v-list-item><!-- logout -->
    </v-list><!-- list -->
  </v-menu>
</template>

<script>
export default {
  props: {
    isMobile: Boolean
  },
  // data () {
  //   return {
  //     loggedUserMenu: [
  //       { title: this.$t('nav.dropdow.item-1'), link: '/profile' },
  //       // { title: 'Settings', link: '/settings' }
  //     ],
  //     loggedUserMenuMobile: [
  //       { title: this.$t('nav.item-1'), link: '/dashboard' },
  //       { title: this.$t('nav.item-2'), link: '/faq' },
  //       { title: this.$t('nav.item-3'), link: '/questions' },
  //       { title: this.$t('nav.dropdow.item-1'), link: '/profile' },
  //     ]
  //   }
  // },

  computed: {
    loggedUserMenu () {
      return [
        { title: this.$t('nav.dropdow.item-1'), link: '/profile' }
        // { title: 'Settings', link: '/settings' }
      ]
    },
    loggedUserMenuMobile () {
      return [
        { title: this.$t('nav.item-1'), link: '/dashboard' },
        { title: this.$t('nav.item-2'), link: '/faq' },
        { title: this.$t('nav.item-3'), link: '/questions' },
        { title: this.$t('nav.dropdow.item-1'), link: '/profile' }
      ]
    }
  },

  methods: {
    logout (options) {
      this.$store.dispatch('auth/authLogout')
      // this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn--icon {
  position: relative;
  & .v-avatar {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.bg-link {
  background: rgba($light-grey, 40%) !important;
}
.v-menu__content {
  @include mq(lg, max) {
    width: 100%;
    max-width: 200px !important;
  }
}
.error--text {
  @include mq(lg, max) {
    justify-content: flex-start !important;
  }
}
</style>
